import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormLabel,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import React, { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import { addSkills, updateSkills } from "Slices/thunks";
import { useFormik } from "formik";
import * as yup from "yup";

const AddSkill = ({ open, setOpen, skill, setSkill }) => {
  const dispatch = useDispatch();

  const { Common, Translation } = useSelector((state) => ({
    Common: state.Common.common,
    Translation: state.Translation.translation?.Settings || {},
  }));

  const Schema = useMemo(() => {
    return yup.object({
      SkillID: yup.string().required(Translation?.SkillRequired || "Skill is required field."),
      YearID: yup.string().required(Translation?.YearRequired || "Year is required field."),
      MonthID: yup.string().required(Translation?.MonthRequired || "Month is required field.")
    });
  }, [Translation])

  const {
    dirty,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    resetForm,
    touched,
    setFieldValue,
  } = useFormik({
    initialValues: skill,
    enableReinitialize: true,
    onSubmit: (data) => {
      const skillObj = {
        ID: skill.ID,
        SkillID: data.SkillID,
        YearID: data.YearID,
        MonthID: data.MonthID
      }

      skill.ID ?
      dispatch(updateSkills(skillObj)) : 
      dispatch(addSkills(skillObj))

      setSkill({});
      setOpen(false);
    },
    validationSchema: Schema,
  });

  const handleClose = () => {
    setOpen(false);
  };

  // const [skills, setSkills] = useState([
  //   {
  //     skill: null,
  //     exp_year: null,
  //     exp_month: null,
  //   },
  //   {
  //     skill: null,
  //     exp_year: null,
  //     exp_month: null,
  //   }
  // ]);


  const onChange = (name, value) => {
    setFieldValue(name, value);
  }

  return (
    <Dialog
      fullWidth
      maxWidth={"sm"}
      open={Boolean(open)}
      onClose={() => handleClose()}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
      <DialogTitle>
        {" "}
        {Translation?.Skill}{" "}
        <IconButton onClick={() => handleClose()}>
          {" "}
          <PrimaryIcon
            icon={CloseIcon}
            color="white"
            height="14px"
            width="14px"
          />{" "}
        </IconButton>{" "}
      </DialogTitle>
      <DialogContent>
      <Box display={"flex"} alignItems={"center"} gap={"20px"}>
        <FormControl fullWidth>
          <FormLabel color="secondary" required label>
            {Translation?.Skills}
          </FormLabel>
          <Box display={"flex"} flexDirection={"column"} gap="10px">
            <Autocomplete
              options={(Common?.Skills || [])}
              fullWidth
              autoHighlight
              getOptionLabel={(option) => option?.Value}
              clearIcon={false}
              value={(Common?.Skills || []).find((item) => item.ID == values.SkillID)}
              onChange={(value, newVal) => onChange('SkillID', newVal?.ID)}
              noOptionsText={<Typography>{Translation?.NoResultsFound}</Typography>}
              renderOption={(props, option) => {
                const { key, ...optionProps } = props;
                return (
                  <Typography key={key} {...optionProps}>
                    {option?.Value}
                  </Typography>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  name="SkillID"
                  onBlur={handleBlur}
                  error={touched.SkillID && errors.SkillID}
                  helperText={touched.SkillID && errors.SkillID && errors.SkillID}
                  placeholder={"Select Skills"}
                  slotProps={{
                    htmlInput: {
                      ...params.inputProps,
                      autoComplete: "new-password",
                    },
                  }}
                />
              )}
            />
          </Box>
        </FormControl>
        <FormControl fullWidth>
          <FormLabel color="secondary" required label>
            {Translation?.Proficiency}
          </FormLabel>
          {/* <Box display={"flex"} flexDirection={"column"} gap="10px">
            {skills?.map((item, i) => {
              return (
                <>
                  <Box
                    key={`exp_year${i}`}
                    display={"flex"}
                    alignItems={"center"}
                    gap={"16px"}
                  >
                    <Autocomplete
                      options={expYears}
                      autoHighlight
                      fullWidth
                      getOptionLabel={(option) => option.label}
                      clearIcon={false}
                      renderOption={(props, option) => {
                        const { key, ...optionProps } = props;
                        return (
                          <Typography key={key} {...optionProps}>
                            {option.label}
                          </Typography>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          placeholder={Translation?.Year}
                          slotProps={{
                            htmlInput: {
                              ...params.inputProps,
                              autoComplete: "new-password",
                            },
                          }}
                        />
                      )}
                    />

                    <Autocomplete
                      key={`exp_month${i}`}
                      options={expMonths}
                      autoHighlight
                      getOptionLabel={(option) => option.label}
                      fullWidth
                      clearIcon={false}
                      renderOption={(props, option) => {
                        const { key, ...optionProps } = props;
                        return (
                          <Typography key={key} {...optionProps}>
                            {option.label}
                          </Typography>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          placeholder={Translation?.Month}
                          slotProps={{
                            htmlInput: {
                              ...params.inputProps,
                              autoComplete: "new-password",
                            },
                          }}
                        />
                      )}
                    />
                    <IconButton
                      onClick={() => {
                        let temp = skills?.filter(
                          (item, index) => i != index
                        );
                        setSkills(temp);
                      }}
                      sx={{ marginLeft: "-10px" }}
                    >
                      <PrimaryIcon
                        icon={CloseIcon}
                        height="12px"
                        width="12px"
                      />
                    </IconButton>
                  </Box>
                </>
              );
            })}
          </Box> */}

          <Box display={"flex"} flexDirection={"column"} gap="10px">
            <Box
              display={"flex"}
              alignItems={"center"}
              gap={"16px"}
            >
              <Autocomplete
                options={(Common?.ExperienceYear || [])}
                autoHighlight
                fullWidth
                getOptionLabel={(option) => option.Value}
                clearIcon={false}
                value={(Common?.ExperienceYear || []).find((item) => item.ID == values.YearID)}
                onChange={(value, newVal) => onChange('YearID', newVal?.ID)}
                noOptionsText={<Typography>{Translation?.NoResultsFound}</Typography>}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  return (
                    <Typography key={key} {...optionProps}>
                      {option.Value}
                    </Typography>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    name="YearID"
                    onBlur={handleBlur}
                    error={touched.YearID && errors.YearID}
                    helperText={touched.YearID && errors.YearID && errors.YearID}
                    placeholder={Translation?.Year}
                    slotProps={{
                      htmlInput: {
                        ...params.inputProps,
                        autoComplete: "new-password",
                      },
                    }}
                  />
                )}
              />

              <Autocomplete
                options={(Common?.ExperienceMonth || [])}
                autoHighlight
                getOptionLabel={(option) => option.Value}
                fullWidth
                clearIcon={false}
                value={(Common?.ExperienceMonth || []).find((item) => item.ID == values.MonthID)}
                onChange={(value, newVal) => onChange('MonthID', newVal?.ID)}
                noOptionsText={<Typography>{Translation?.NoResultsFound}</Typography>}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  return (
                    <Typography key={key} {...optionProps}>
                      {option.Value}
                    </Typography>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    name="MonthID"
                    onBlur={handleBlur}
                    error={Boolean(touched.MonthID && errors.MonthID)}
                    helperText={touched.MonthID && errors.MonthID && errors.MonthID}
                    placeholder={Translation?.Month}
                    slotProps={{
                      htmlInput: {
                        ...params.inputProps,
                        autoComplete: "new-password",
                      },
                    }}
                  />
                )}
              />
              {/* <IconButton
                onClick={() => {
                  let temp = skills?.filter(
                    (item, index) => i != index
                  );
                  setSkills(temp);
                }}
                sx={{ marginLeft: "-10px" }}
              >
                <PrimaryIcon
                  icon={CloseIcon}
                  height="12px"
                  width="12px"
                />
              </IconButton> */}
            </Box>
          </Box>
        </FormControl>
      </Box>
      </DialogContent>
      <DialogActions primary>
        <Button
          onClick={() => handleClose()}
          variant="outlined"
          color="secondary"
        >
          {Translation?.Cancel}
        </Button>
        <Button type="submit" variant="contained">
          {Translation?.SaveChanges}
        </Button>
      </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddSkill;
